import moment from 'moment'
import {helperIsComma, helperConverDateJST, arrangePostCodeAddHyphen} from '@/js/util/helper'
import * as Adjust from '@/js/util/adjust'

/**
 * APIから取得した個人情報データを,
 * 個人情報入力フォームに合うよう整形する
 * @param {object} contract 契約情報
 * @param {object} customer 個人情報
 * @param {string} hasPayment 現在の申込種別
 *
 * @return {object|null} 整形データ
 */
export const TransUserInputFromWebApi = (contract, customer, hasPayment) => {
  const d = contract,
    c = customer

  if (!d && !c) return null

  // STEP4の入力内容 データ整理
  const userForm = {
    application_date_year: null, // 申込日(年)
    application_date_month: null, // 申込日(月)
    application_date_day: null, // 申込日(日)
    purpose_of_transaction: c.purpose_of_transaction, // 取引を行う目的
    purpose_of_transaction_other_name: c.purpose_of_transaction_other_name, // 取引を行う目的
    is_foreign_government: c.is_foreign_government, // 外国政府等重要な公的地位にある方等とのお取引に該当する
    foreign_government_company: c.foreign_government_company, // 外国政府等重要な公的地位にある方等とのお取引に該当する 国名と職名
    surname: d.surname, // 姓
    first_name: d.name, // 名
    surname_kana: d.surname_kana, // 姓(フリガナ)
    first_name_kana: d.name_kana, // 名(フリガナ)
    sex_type: c.sex_type, // 性別
    birthday_year: c.birthday ? moment(c.birthday).year().toString() : null, // 生年月日(年)
    birthday_month: c.birthday ? (moment(c.birthday).month() + 1).toString() : null, // 生年月日(月)
    birthday_day: c.birthday ? moment(c.birthday).date().toString() : null, // 生年月日(日)
    post_number: arrangePostCodeAddHyphen(c.post_number), // 郵便番号
    street_address1: c.street_address1, // 住所1
    street_address2: (c.street_address2 ?? '') + (c.street_address3 ?? ''), // 住所2
    street_address_kana: c.street_address1_kana, // 住所カナ(住所1のカナ)
    fixed_phone1: c.fixed_phone ? c.fixed_phone.split('-')[0] ?? null : null, // 固定電話
    fixed_phone2: c.fixed_phone ? c.fixed_phone.split('-')[1] ?? null : null, // 固定電話
    fixed_phone3: c.fixed_phone ? c.fixed_phone.split('-')[2] ?? null : null, // 固定電話
    mobile_phone1: c.mobile_phone ? c.mobile_phone.split('-')[0] ?? null : null, // 携帯電話
    mobile_phone2: c.mobile_phone ? c.mobile_phone.split('-')[1] ?? null : null, // 携帯電話
    mobile_phone3: c.mobile_phone ? c.mobile_phone.split('-')[2] ?? null : null, // 携帯電話
    family_about: c.family_about, // ご家族について
    family_about_number: c.family_about_number, // 同居人数
    family_structure: c.family_structure, // 生計同一人数
    residence_classification: c.residence_classification1, // 住居形態
    residence_period_year: c.residence_period_year, // 居住年数(年)
    loan_rent: c.loan_rent, // ローン有無
    occupation: Adjust.adjustOccupation(c.occupation, hasPayment), // お勤め先・学校について
    occupation_other_name: c.occupation_other_name,
    student_unemployed_flg: c.student_unemployed_flg, // 無職フラグ
    householder_relation: c.householder_relation, // 世帯主との関係
    householder_income: c.householder_income, // 世帯主収入
    householder_income_type: c.householder_income_type, // 世帯主の所得種類
    householder_income_type_other_name: c.householder_income_type_other_name, // 世帯主の所得種類 その他の場合のテキスト
    householder_monthly_credit_payments: c.householder_monthly_credit_payments, // 世帯主のクレジット月間支払い額
    parents_post: arrangePostCodeAddHyphen(c.parents_post), // 実家郵便番号
    parents_address: c.parents_address1, // 実家住所
    parents_phone1: c.parents_phone ? c.parents_phone.split('-')[0] ?? null : null, // 実家電話番号
    parents_phone2: c.parents_phone ? c.parents_phone.split('-')[1] ?? null : null, // 実家電話番号
    parents_phone3: c.parents_phone ? c.parents_phone.split('-')[2] ?? null : null, // 実家電話番号
    parents_phone_exists: c.parents_phone ? true : false,  // 実家固定電話のチェックボックス
    parents_mobile_phone1: c.parents_mobile_phone ? c.parents_mobile_phone.split('-')[0] ?? null : null, // 実家携帯電話番号
    parents_mobile_phone2: c.parents_mobile_phone ? c.parents_mobile_phone.split('-')[1] ?? null : null, // 実家携帯電話番号
    parents_mobile_phone3: c.parents_mobile_phone ? c.parents_mobile_phone.split('-')[2] ?? null : null, // 実家携帯電話番号
    parents_mobile_exists: c.parents_mobile_phone ? true : false,  // 実家携帯電話のチェックボックス
    parents_phone_relationship: c.parents_phone_relationship,  // 実家携帯電話の続柄
    parents_phone_relationship_other_name: c.parents_phone_relationship_other_name,  // 実家携帯電話の続柄(その他)
    graduate_year: c.graduate_year, // 卒業予定(年)
    graduate_month: c.graduate_month, // 卒業予定(月)
    company_name: c.company_name, // お勤め先
    company_name_kana: c.company_name_kana, // お勤め先カナ
    company_phone1: c.company_phone ? c.company_phone.split('-')[0] ?? null : null, // お勤め先電話番号
    company_phone2: c.company_phone ? c.company_phone.split('-')[1] ?? null : null, // お勤め先電話番号
    company_phone3: c.company_phone ? c.company_phone.split('-')[2] ?? null : null, // お勤め先電話番号
    company_job_description: c.company_job_description, // 仕事内容
    company_job_description_other_name: c.company_job_description_other_name, // 仕事内容 その他の場合のテキスト
    job_department: c.job_department, // 所属部課
    dispatched_agent: c.dispatched_agent, // 出向派遣元
    company_post: arrangePostCodeAddHyphen(c.company_post), // 勤め先郵便番号
    company_address: c.company_address1, // 勤め先住所
    join_year: c.join_year, // 入社年月(年)
    join_month: c.join_month, // 入社年月(月)
    payday: c.payday, // 給料日
    company_income: c.company_income, // 税込年収
    sideline_type: c.sideline_type, // その他収入
    sideline_other_name: c.sideline_other_name, // その他収入 その他の場合のテキスト
    sideline_income: c.sideline_income, // その他収入(年額)
    is_change_customer: 0 // 変更フラグ ※追加 / 変更申込の場合 デフォルトで未選択にする
  }

  return userForm
}

/**
 * APIから取得した商品情報データを,
 * 商品入力フォームに合うよう整形する
 * @param {object} contract 契約情報
 * @return {object|null} 整形データ
 */
export const TransProductInputFromWebApi = (contract) => {
  const d = contract

  const product = d.products.length ? d.products[0] : null

  if (!d) return null

  // STEP1の入力内容 データ整理
  const productForm = {
    product: product ? product.store_product_id : null, // 商品情報
    product_other_name: product ? product.product_other_name : null, // 商品情報 その他候補
    service_start_date: d.service_start_date, // 役務提供開始
    service_end_date: d.service_end_date, // 役務提供終了
    cash_total: d.cash_total ? helperIsComma(d.cash_total) : '0', // 現金価格合計
    down_payment: d.down_money ? helperIsComma(d.down_money) : '0', // 頭金
    remaining_money: d.remaining_money ? helperIsComma(d.remaining_money) : '0', // 残金
    finance_category_name: d.finance_category_name, // 金融カテゴリー名
    payment: d.pay_type, // 支払方法
    split_number: d.split_count ? String(d.split_count) : null, // 分割回数
    bonus_combined_addition_amount: d.bonus_combined_addition_amount
      ? helperIsComma(d.bonus_combined_addition_amount)
      : '0', //ボーナス併用加算額
    bonus_combined_month1: d.bonus_combined_month1, // ボーナス加算月
    bonus_combined_month2: d.bonus_combined_month2, // ボーナス加算月
    bonus_combined_number: d.bonus_combined_number, //ボーナス加算回数
    bonus_once_month: helperConverDateJST(d.bonus_once_month), // 支払月1回目
    bonus_twice_month: helperConverDateJST(d.bonus_twice_month), //支払月2回目
    payment_period_start: helperConverDateJST(d.payment_period_start), // 支払期間 開始
    payment_period_end: helperConverDateJST(d.payment_period_end), // 支払期間 終了
    payment_amount_once: d.payment_amount_once ? helperIsComma(d.payment_amount_once) : '0', // 支払金額 第1回目
    payment_amount_second: d.payment_amount_second ? helperIsComma(d.payment_amount_second) : '0', // 支払金額 第2回目以降
    split_fee: d.split_fee ? helperIsComma(d.split_fee) : '0', // 分割手数料
    split_total_payment: d.split_total_payment ? helperIsComma(d.split_total_payment) : '0', // 分割支払合計
    total_pay: d.total_pay ? helperIsComma(d.total_pay) : '0', // 支払総額
    person_charge: d.staff_name // 担当者
  }

  return productForm
}

/**
 * APIから取得した写真登録（口座振替）データを,
 * 写真登録（口座振替）入力フォームに合うよう整形する
 * @param {object} contract 契約情報
 * @return {object|null} 整形データ
 */
export const TransUploadInputFromWebApi = (contract) => {
  const d = contract

  if (!d) return null

  const uploadedImages = {
    identification: [], // 本人確認書類
    contract_documents: [], // エステ契約書、美容医療契約書、売買契約書、口座振替依頼書等
    parental_consent: [] // 親権者同意書
  }

  if (d.images) {
    for (let [key, images] of Object.entries(d.images)) {
      images = Object.values(images) // 配列かObjectで来るので配列に統一
      images.forEach((img) => {
        const transformKey = key === 'identifications' ? 'identification' : key
        uploadedImages[transformKey].push({
          image: img.url,
          id: img.id,
          can_delete: false,
          delete: false,
          see: false
        })
      })
    }
  }

  // STEP6の入力内容 データ整理
  const uploadForm = {
    bank_account_holder: d.bank_account_holder,
    bank_account_holder_name: d.bank_account_holder_name,
    bank_account_registration: d.bank_account_registration,
    bank_account_registration_date: d.bank_account_registration_date,
    is_beri: d.is_beri, // 本人確認電話フラグ
    beri_timing: d.beri_timing, // 確認日時
    beri_at: d.beri_at, // ベリ指定日時
    ...uploadedImages
  }

  return uploadForm
}

/**
 * TFICから取得した個人情報データを,
 * 個人情報入力フォームに合うよう整形する
 * @param {object} detail 個人情報
 * @param {string} hasPayment 現在の申込種別
 *
 * @return {object|null} 整形データ
 */
export const TransUserInputFromTfic = (detail, hasPayment) => {
  const d = detail

  if (!d) return null

  // STEP4の入力内容 データ整理
  const userForm = {
    application_date_year: null, // 申込日(年)
    application_date_month: null, // 申込日(月)
    application_date_day: null, // 申込日(日)
    purpose_of_transaction: d.purpose_of_transaction, // 取引を行う目的
    purpose_of_transaction_other_name: d.purpose_of_transaction_other_name, // 取引を行う目的
    is_foreign_government: d.is_foreign_government, // 外国政府等重要な公的地位にある方等とのお取引に該当する
    foreign_government_company: d.foreign_government_company, // 外国政府等重要な公的地位にある方等とのお取引に該当する 国名と職名
    surname: d.surname, // 姓
    first_name: d.name, // 名
    surname_kana: d.surname_kana, // 姓(フリガナ)
    first_name_kana: d.name_kana, // 名(フリガナ)
    sex_type: d.sex_type, // 性別
    birthday_year: d.birthday_year,
    birthday_month: d.birthday_month,
    birthday_day: d.birthday_day,
    post_number: arrangePostCodeAddHyphen(d.post_number), // 郵便番号
    street_address1: d.street_address1, // 住所1
    street_address2: d.street_address2, // 住所2
    street_address_kana: d.street_address_kana, // 住所カナ(住所1のカナ)
    fixed_phone1: d.fixed_phone1,
    fixed_phone2: d.fixed_phone2,
    fixed_phone3: d.fixed_phone3,
    mobile_phone1: d.mobile_phone1,
    mobile_phone2: d.mobile_phone2,
    mobile_phone3: d.mobile_phone3,
    family_about: d.family_about, // ご家族について
    family_about_number: d.family_about_number, // 同居人数
    family_structure: d.family_structure, // 生計同一人数
    residence_classification: d.residence_classification1, // 住居形態
    residence_period_year: d.residence_period_year, // 居住年数(年)
    loan_rent: d.loan_rent, // ローン有無
    occupation: Adjust.adjustOccupation(d.occupation, hasPayment), // お勤め先・学校について
    occupation_other_name: d.occupation_other_name,
    householder_relation: d.householder_relation, // 世帯主との関係
    householder_income: d.householder_income, // 世帯主収入
    householder_income_type: d.householder_income_type, // 世帯主の所得種類
    householder_income_type_other_name: d.householder_income_type_other_name, // 世帯主の所得種類 その他の場合のテキスト
    householder_monthly_credit_payments: d.householder_monthly_credit_payments, // 世帯主のクレジット月間支払い額
    parents_post: arrangePostCodeAddHyphen(d.parents_post), // 実家郵便番号
    parents_address: d.parents_address1, // 実家住所
    parents_phone1: d.parents_phone1,
    parents_phone2: d.parents_phone2,
    parents_phone3: d.parents_phone3,
    parents_phone_exists: d.parents_phone1 || d.parents_phone2 || d.parents_phone3 ? true : false,  // 実家固定電話のチェックボックス
    parents_mobile_phone1: d.parents_mobile_phone1, // 実家携帯電話番号
    parents_mobile_phone2: d.parents_mobile_phone2, // 実家携帯電話番号
    parents_mobile_phone3: d.parents_mobile_phone3, // 実家携帯電話番号
    parents_mobile_exists: d.parents_mobile_phone1 || d.parents_mobile_phone2 || d.parents_mobile_phone3 ? true : false,  // 実家携帯電話のチェックボックス
    parents_phone_relationship: d.parents_phone_relationship,  // 実家携帯電話の続柄
    parents_phone_relationship_other_name: d.parents_phone_relationship_other_name,  // 実家携帯電話の続柄(その他)
    graduate_year: d.graduate_year, // 卒業予定(年)
    graduate_month: d.graduate_month, // 卒業予定(月)
    company_name: d.company_name, // お勤め先
    company_name_kana: d.company_name_kana, // お勤め先カナ
    company_phone1: d.company_phone1,
    company_phone2: d.company_phone2,
    company_phone3: d.company_phone3,
    company_job_description: d.company_job_description, // 仕事内容
    company_job_description_other_name: d.company_job_description_other_name, // 仕事内容 その他の場合のテキスト
    job_department: d.job_department, // 所属部課
    dispatched_agent: d.dispatched_agent, // 出向派遣元
    company_post: arrangePostCodeAddHyphen(d.company_post), // 勤め先郵便番号
    company_address: d.company_address, // 勤め先住所
    join_year: d.join_year, // 入社年月(年)
    join_month: d.join_month, // 入社年月(月)
    payday: d.payday, // 給料日
    company_income: d.company_income, // 税込年収
    sideline_type: d.sideline_type, // その他収入
    sideline_other_name: d.sideline_other_name, // その他収入 その他の場合のテキスト
    sideline_income: d.sideline_income, // その他収入(年額)
    is_change_customer: 0 // 変更フラグ ※追加 / 変更申込の場合 デフォルトで未選択にする
  }

  return userForm
}

/**
 * TFICから取得した写真登録（口座振替）データを,
 * 写真登録（口座振替）入力フォームに合うよう整形する
 * @param {object} detail 契約情報
 * @return {object|null} 整形データ
 */
export const TransUploadInputFromTfic = (detail) => {
  const d = detail

  if (!d) return null

  // STEP6の入力内容 データ整理
  const uploadForm = {
    bank_account_holder: d.bank_account_holder,
    bank_account_holder_name: d.bank_account_holder_name,
    bank_account_registration: d.bank_account_registration,
    identification: [], // 本人確認書類
    contract_documents: [], // エステ契約書、美容医療契約書、売買契約書、口座振替依頼書等
    parental_consent: [], // 親権者同意書
    is_beri: true, // 本人確認電話フラグ
    beri_timing: '審査後すぐ', // 確認日時
    beri_at: null // ベリ指定日時
  }
}
